module.exports = __webpack_public_path__ + "img/cal.c57fd2df.svg";